<template>
  <div class="filter-price">
    <div class="filter-price__inner">
      <filter-vue
        :name="name"
        :show-option-on-count-zero="true"
      />
      <range-slider
        class="filter-price__range-slider"
        ref="rangeSlider"
        :min-value-symbol="filters[index].currencySymbol"
        :max-value-symbol="filters[index].currencySymbol"
        :initial-range-min="filters[index].minPriceRange"
        :initial-range-max="filters[index].maxPriceRange"
        :initial-min-value="filters[index].minPrice"
        :initial-max-value="filters[index].maxPrice"
        :min-input-name="filters[index].priceMinInputName"
        :max-input-name="filters[index].priceMaxInputName"
        @change="priceRangeChangeHandler"
      />
    </div>
  </div>
</template>

<script>
import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js'
import RangeSlider from '../rangeSlider/rangeSlider.vue'
import FilterVue from '../filter/filter.vue'

  export default {
    mixins: [
      plpStateComputedMixin
    ],
    components: {
      RangeSlider,
      FilterVue
    },
    props: {
      name: {
        type: String,
        default: null
      },
      updatePageOnChange: {
        type: Boolean,
        default: true
      }
    },
    created() {
      const vm = this;
      this.$store.subscribe(mutation => {
        if (mutation.type === 'productsListPage/removeAllActiveFilterOptions' ||
          mutation.type === 'productsListPage/removeActiveFilterOption') {
          vm.$refs.rangeSlider.resetValues();
        }
        if (mutation.type === 'productsListPage/updateFiltersState') {
          const priceFilter = mutation.payload.find(filter => filter.name === this.name);
          if (priceFilter) {
            vm.$refs.rangeSlider.setValues([priceFilter.minPrice, priceFilter.maxPrice]);
          }
        }
      });
    },
    computed: {
      index() {
        return this.filters.findIndex(filter => filter.name === this.name);
      }
    },
    methods: {
      priceRangeChangeHandler() {
        this.priceOption = null;
        this.priceRangeUpdate(true);
      },
      getRangePriceValueData(type) {
        return this.$refs.rangeSlider.getValues()[type === 'min' ? 0 : 1];
      },
      priceRangeUpdate(updatePage) {
        this.$store.dispatch('productsListPage/filterPriceRangeUpdate', {
          index: this.index,
          minPrice: this.getRangePriceValueData('min'),
          maxPrice: this.getRangePriceValueData('max'),
          updatePageOnChange: updatePage
        });
      }
    }
  };

</script>
